var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324_36)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 3.9C1.2 2.40883 2.40883 1.2 3.9 1.2H11.4C12.1732 1.2 12.8 1.8268 12.8 2.6V2.69999C12.8 3.03136 13.0686 3.29999 13.4 3.29999C13.7314 3.29999 14 3.03136 14 2.69999V2.6C14 1.16406 12.8359 0 11.4 0H3.9C1.74609 0 0 1.74609 0 3.9V11.4C0 12.8359 1.16406 14 2.6 14H2.70009C3.03146 14 3.30009 13.7314 3.30009 13.4C3.30009 13.0686 3.03146 12.8 2.70009 12.8H2.6C1.8268 12.8 1.2 12.1732 1.2 11.4V3.9ZM7.2 9.9C7.2 8.40883 8.40883 7.2 9.9 7.2H16.1C17.5912 7.2 18.8 8.40883 18.8 9.9V16.1C18.8 17.5912 17.5912 18.8 16.1 18.8H9.9C8.40883 18.8 7.2 17.5912 7.2 16.1V9.9ZM9.9 6C7.74609 6 6 7.74609 6 9.9V16.1C6 18.2539 7.74609 20 9.9 20H16.1C18.2539 20 20 18.2539 20 16.1V9.9C20 7.74609 18.2539 6 16.1 6H9.9Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8d718d011a434d18c157bf26d4a1ecf2.svg";
export { ForwardRef as ReactComponent };